import React from 'react';
import '../checkbox.scss';

const EnabledIndeterminate = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <g
      id="input-/-checkbox-/-indeterminate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        fill="#0078A0"
        x="0"
        y="0"
        width="16"
        height="16"
        rx="2"
      ></rect>
      <path
        d="M5,8 L11,8"
        id="Line"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export default React.memo(EnabledIndeterminate);
